import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { toastrNotification } from '../../helpers/Toastr'
import { client } from '../Client'

const DeleteConfirmationModal = ({course, license, currentLection, addNote, videoPlayerRef}) => {
  
  const handleClose = () => {
    $('body').removeClass('shadow')
  }

  return (
    
    <>
    <div className="confirm_modal" id="deleteConfirmationModal">
      <div className="modal_header">
          <div className="container" onClick={handleClose}>
              <svg id="close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M14.75 14.75L1.25 1.25" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.75 1.25L1.25 14.75" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
          </div>
      </div>
      <div className="container user_form">
        <div className="modal_body d-flex flex-column">
          <h3 className="confirm-title">{window.t("course_viewer.destroy_confirm_title")}</h3>
          <p className="confirm-text">{window.t("course_viewer.destroy_confirm_text")}</p>
          <div className="d-flex justify-content-center">
            <button id="cancel" onClick={handleClose} type="button" className="btn btn-pill btn-info my-1 btn-del-room">
              {window.t('cancel')}
            </button>
            <button>{window.t('delete')}</button>
          </div>
        </div>
      </div>
        
    </div>
    </>
  )
}

export default DeleteConfirmationModal